import { questionSetStore } from "./question-set-store";

export type * from "./question-set-store";
export { mintQuestionnaireDefinitionUrl, QUESTIONNAIRE_DEFINITION_CANONICAL_BASE } from "./question-set-store";

export const {
  projectQuestionnaireDefinition,
  useQuestionnaireDefinitions,
  useQuestionnaireDefinition,
  defineQuestionnaireDefinition,
  reviseQuestionnaireDefinition,
  correctQuestionnaireDefinition,
  activateQuestionnaireDefinition,
  deactivateQuestionnaireDefinition,
} = questionSetStore(false);
